/**
 * Clipboard write with a fallback for browsers/contexts without the async API
 * (notably non-HTTPS origins, where `navigator.clipboard` is undefined).
 */
export const copyToClipboard = async (value: string): Promise<boolean> => {
    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            return true;
        }
    } catch {
        // Fall through to the legacy path below.
    }
    try {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        return ok;
    } catch {
        return false;
    }
};
